import { getImg } from "./index"

export function ImgFilter(v, type) {
    return getImg(v, type)
}